export interface MatOption<T = any, P = any> {
  value: T;
  viewValue: string;
  disabled?: boolean;
  selected?: boolean;
  source?: P;
}
